import React, { useState, useEffect, useRef } from "react";
import  { useNavigate, Navigate } from 'react-router-dom'
import { baseUrl } from '../../shared.js';
import { StatusChip } from '../../components/ui';
import '../App.css';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import { Toolbar, Typography } from "@mui/material";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import moment from 'moment';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from "@mui/x-date-pickers";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from "@mui/material/TableHead";
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from "@mui/material/TableRow";
import Paper from '@mui/material/Paper';
import Autocomplete from '@mui/material/Autocomplete';
import Alert from '@mui/material/Alert';

function Timesheet({ foundTimesheet, onCancel }) {
  const [changed, setChanged] = useState(false);
  const [timesheetData, setTimesheetData] = useState(foundTimesheet);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
    var [partsList, setPartsList] = useState([]);
  const [timesheetPartData, setTimesheetPartData] = useState();
  const [partsLoaded, setPartsLoaded] = useState(false);
  const [partDetailOpen, setPartDetailOpen] = useState(false);
  const [deletePartConfirm, setDeletePartConfirm] = useState(false);
  const navigate = useNavigate();

  const isSynced = timesheetData?.omnixSyncStatus === 'SYNCED';

  // Omnix job card typeahead state
  const canUseOmnix = localStorage.getItem('canUseOmnixIntegration') === '1';
  const companyCode = foundTimesheet?.customer || null;
  const [omnixLink, setOmnixLink] = useState(null);         // link row or null (checked)
  const [omnixLinkChecked, setOmnixLinkChecked] = useState(false);
  const [omnixOffline, setOmnixOffline] = useState(false);
  const [jobCardOptions, setJobCardOptions] = useState([]);
  const [jobCardInput, setJobCardInput] = useState('');
  const [selectedJobCard, setSelectedJobCard] = useState(null);
  const jcSearchTimer = useRef(null);

  // Check for Omnix company link when component mounts with a companyCode
  useEffect(() => {
    if (!canUseOmnix || !companyCode) return;
    fetch(baseUrl + 'omnix/company-links/by-company/' + encodeURIComponent(companyCode), {
      headers: { username: localStorage.getItem('username'), bToken: localStorage.getItem('bToken') },
    })
      .then(r => r.json())
      .then(data => { setOmnixLink(data); setOmnixLinkChecked(true); })
      .catch(() => { setOmnixLink(null); setOmnixLinkChecked(true); });
  }, [canUseOmnix, companyCode]);

  // Item search state (for parts dialog)
  const [itemOptions, setItemOptions] = useState([]);
  const [itemInput, setItemInput] = useState('');
  const [selectedItem, setSelectedItem] = useState(null);
  const [stockLevel, setStockLevel] = useState(null);
  const [stockOnOrder, setStockOnOrder] = useState(null);
  const itemSearchTimer = useRef(null);

  const handleItemSearch = (value) => {
    setItemInput(value);
    if (itemSearchTimer.current) clearTimeout(itemSearchTimer.current);
    if (!value) { setItemOptions([]); return; }
    itemSearchTimer.current = setTimeout(() => {
      fetch(baseUrl + 'omnix/items?q=' + encodeURIComponent(value), {
        headers: { username: localStorage.getItem('username'), bToken: localStorage.getItem('bToken') },
      })
        .then(r => r.json())
        .then(data => setItemOptions(Array.isArray(data) ? data : []))
        .catch(() => setItemOptions([]));
    }, 300);
  };

  const handleItemSelect = (item) => {
    setSelectedItem(item);
    setStockLevel(null);
    setStockOnOrder(null);
    if (!item) return;
    fetch(baseUrl + 'omnix/items/' + item.id + '/stock', {
      headers: { username: localStorage.getItem('username'), bToken: localStorage.getItem('bToken') },
    })
      .then(r => r.json())
      .then(data => {
        setStockLevel(data.totalOnHand ?? null);
        setStockOnOrder(data.totalOnOrder ?? null);
      })
      .catch(() => { setStockLevel(null); setStockOnOrder(null); });
  };

  // Reset item state when part dialog opens for a new part
  useEffect(() => {
    if (partDetailOpen) {
      setSelectedItem(null);
      setItemOptions([]);
      setItemInput('');
      setStockLevel(null);
      setStockOnOrder(null);
    }
  }, [partDetailOpen]);

  // Pre-load parts for an existing timesheet so the Parts Used list is shown immediately
  // (loadParts has its own error catch, so a failure won't break the form).
  useEffect(() => {
    if (timesheetData?.id) loadParts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timesheetData?.id]);

  // Job card search
  const handleJobCardSearch = (value) => {
    setJobCardInput(value);
    if (jcSearchTimer.current) clearTimeout(jcSearchTimer.current);
    if (!omnixLink) return;
    const customerId = omnixLink.omnixCustomerId;
    jcSearchTimer.current = setTimeout(() => {
      const qs = new URLSearchParams({ customerId });
      if (value) qs.set('q', value);
      fetch(baseUrl + 'omnix/jobcards?' + qs.toString(), {
        headers: { username: localStorage.getItem('username'), bToken: localStorage.getItem('bToken') },
      })
        .then(r => r.json())
        .then(data => {
          if (data.offline) { setOmnixOffline(true); setJobCardOptions([]); }
          else { setOmnixOffline(false); setJobCardOptions(data.items || []); }
        })
        .catch(() => { setOmnixOffline(true); setJobCardOptions([]); });
    }, 300);
  };

console.log('timehsheet data: ',timesheetData)


async function createTimesheet(e) {
  e.preventDefault();
  const url = baseUrl+'timesheet/create/';
  await fetch(url, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'username': localStorage.getItem('username'),
          'bToken': localStorage.getItem('bToken')
      },
      body: JSON.stringify(timesheetData),
  })
      .then((response) => response.json())
        .then((data) => {
          console.log(data)
          if( data[0].status === 200) {
                // <Navigate to={'/?catNo='+[timesheetData.catNo]} />
                // navigate(0)
                setTimesheetData(data[0].createdTimesheet)
          } else if (data.status === 401) {
          }
        })
        .catch((err) => {
        });
}

async function updateTimesheet(e) {
  e.preventDefault();
  const url = baseUrl+'timesheet/update/';
  await fetch(url, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'username': localStorage.getItem('username'),
          'bToken': localStorage.getItem('bToken')
      },
      body: JSON.stringify(timesheetData),
  })
      .then((response) => response.json())
        .then((data) => {
          console.log(data)
          if( data[0].status === 200) {
                <Navigate to={'/?catNo='+[timesheetData.catNo]} />
                navigate(0)
          } else if (data.status === 401) {
          }
        })
        .catch((err) => {
        });
}

async function deleteTimesheet(e) {
  e.preventDefault();
  const url = baseUrl+'timesheet/delete/';
  await fetch(url, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'username': localStorage.getItem('username'),
          'bToken': localStorage.getItem('bToken')
      },
      body: JSON.stringify(timesheetData),
  })
      .then((data) => {
          console.log(data)
          if( data.status === 200) {
                <Navigate to={'/?catNo='+[timesheetData.catNo]} />
                navigate(0)
          } else if (data.status === 401) {
          }
        })
        .catch((err) => {
        });
}

  const deleteConfirmShow = () => {
    if (deleteConfirm) {
      setDeleteConfirm(false)  
  } else {
    setDeleteConfirm(true)
  }};
  
  function loadParts() {
    const url = baseUrl + 'timesheetPart/list/';
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'username': localStorage.getItem('username'),
        'bToken': localStorage.getItem('bToken')
      },
      body: JSON.stringify(timesheetData)
    })
      .then((res) => {
        return res.json();
      }).then((json) => {
        setPartsList(json);
        showPartsList();
      })
      .catch((err) => {
        console.log(err.message);
      });
      }

async function createPart(e) {
  e.preventDefault();
  const url = baseUrl+'timesheetPart/create/';
  await fetch(url, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'username': localStorage.getItem('username'),
          'bToken': localStorage.getItem('bToken')
      },
      body: JSON.stringify(timesheetPartData),
  })
      .then((response) => response.json())
        .then((data) => {
          console.log(data)
          if( data[0].status === 200) {
                if( showPartsList ) {
                  handlePartDetail()
                  loadParts()
                } else {
                  handlePartDetail()
                }
          } else if (data.status === 401) {
          }
        })
        .catch((err) => {
        });
}

async function updatePart(e) {
  e.preventDefault();
  const url = baseUrl+'timesheetPart/update/';
  await fetch(url, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'username': localStorage.getItem('username'),
          'bToken': localStorage.getItem('bToken')
      },
      body: JSON.stringify(timesheetPartData),
  })
      .then((response) => response.json())
        .then((data) => {
          console.log(data)
          if( data[0].status === 200) {
                if( showPartsList ) {
                  handlePartDetail()
                  loadParts()
                } else {
                  handlePartDetail()
                }
          } else if (data.status === 401) {
          }
        })
        .catch((err) => {
        });
}

async function deletePart(e) {
  e.preventDefault();
  const url = baseUrl+'timesheetPart/delete/';
  await fetch(url, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'username': localStorage.getItem('username'),
          'bToken': localStorage.getItem('bToken')
      },
      body: JSON.stringify(timesheetPartData),
  })
      .then((data) => {
          console.log(data)
          if( data.status === 200) {
                if( showPartsList ) {
                  deletePartConfirmShow()
                  handlePartDetail()
                  loadParts()
                } else {
                  handlePartDetail()
                }
          } else if (data.status === 401) {
          }
        })
        .catch((err) => {
        });
}

  const handlePartDetail = () => {
    if (partDetailOpen) {
      setPartDetailOpen(false)  
  } else {
    setPartDetailOpen(true)
  }};

    function showPartsList() {
      if(partsLoaded) {
        setPartsLoaded(false)
      } else
      { setPartsLoaded(true)}
    }

  const deletePartConfirmShow = () => {
    if (deletePartConfirm) {
      setDeletePartConfirm(false)  
  } else {
    setDeletePartConfirm(true)
  }};

return (
  <Box sx={{ display: 'flex', flexDirection: 'column', maxHeight: '85vh' }}>
    <React.Fragment>
      <Dialog
        open={deleteConfirm}
        onClose={!deleteConfirm}
      >
        <DialogTitle>
        Confirm Deletion of Timesheet
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="confirmDeleteDesc">
            Are you sure you want to delete the Timesheet?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={deleteTimesheet}>OK</Button>
          <Button onClick={deleteConfirmShow}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>

    <React.Fragment>
      <Dialog
        open={deletePartConfirm}
        onClose={!deletePartConfirm}
      >
        <DialogTitle>
        Confirm Deletion of Part from Timesheet
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="confirmDeleteDesc">
            Are you sure you want to delete the Part from the Timesheet?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={deletePart}>OK</Button>
          <Button onClick={deletePartConfirmShow}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>

    <React.Fragment>
          <Dialog
            open={partDetailOpen}
            onClose={handlePartDetail}
          >
            <DialogContent>
              <Toolbar>
              {timesheetPartData?.id === null ? (<h3>Add Part</h3>):(<h3>Update Part</h3>)}
      {timesheetPartData?.id !== null ? (
        <IconButton sx={{ marginLeft: "auto" }}
        aria-label="delete"
        onClick={deletePartConfirmShow}>
        <DeleteIcon />
      </IconButton>
      ):null}
              </Toolbar>
              {/* Part Number — Omnix item search when linked, free-text fallback */}
              {canUseOmnix && omnixLink && !omnixOffline ? (
                <Box margin="dense" sx={{ mt: 1 }}>
                  {!timesheetData?.omnixJobCardId && (
                    <Box sx={{ mb: 1, p: 1, bgcolor: 'warning.light', borderRadius: 1 }}>
                      <Typography variant="caption" color="warning.contrastText">
                        This timesheet is not linked to an Omnix job card — parts added here will not auto-sync to Omnix.
                      </Typography>
                    </Box>
                  )}
                  <Autocomplete
                    options={itemOptions}
                    getOptionLabel={(o) => `${o.name}${o.sku ? ` (${o.sku})` : ''}`}
                    value={selectedItem}
                    onChange={(_, val) => {
                      handleItemSelect(val);
                      setTimesheetPartData({
                        ...timesheetPartData,
                        partNo: val ? (val.sku || val.name) : timesheetPartData?.partNo,
                        omnixItemId: val ? val.id : null,
                      });
                    }}
                    onInputChange={(_, v) => handleItemSearch(v)}
                    isOptionEqualToValue={(a, b) => a.id === b.id}
                    renderInput={(params) => (
                      <TextField {...params} fullWidth margin="dense" label="Part (Omnix)" variant="outlined" placeholder="Search by name or SKU…" />
                    )}
                    noOptionsText={itemInput ? 'No items found' : 'Type to search…'}
                  />
                  {stockLevel !== null && (
                    <Box sx={{ display: 'flex', gap: 2, mt: 0.5 }}>
                      <Typography variant="caption" sx={{ color: stockLevel > 0 ? 'success.main' : 'error.main' }}>
                        On hand: {stockLevel}
                      </Typography>
                      {stockOnOrder !== null && (
                        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                          On order: {stockOnOrder}
                        </Typography>
                      )}
                    </Box>
                  )}
                </Box>
              ) : (
                <Box margin="dense">
                  {canUseOmnix && !omnixLink && (
                    <Box sx={{ mb: 1, p: 1, bgcolor: 'warning.light', borderRadius: 1 }}>
                      <Typography variant="caption" color="warning.contrastText">
                        This company is not linked to an Omnix customer — parts added here will not auto-sync to Omnix.
                      </Typography>
                    </Box>
                  )}
                  <TextField
                    fullWidth
                    margin="dense"
                    id="partNo"
                    label="Part Number"
                    variant="outlined"
                    type="text"
                    value={timesheetPartData?.partNo}
                    onChange={(e) => {
                      setTimesheetPartData({ ...timesheetPartData, partNo: e.target.value });
                    }}
                  />
                </Box>
              )}
              <Box
          margin="dense">
         <TextField
        fullWidth
          margin="dense"
          id="qty"
          label="Qty"
          variant="outlined"
          type="number"
          value={timesheetPartData?.qty}
    onChange={(e) => {
      setChanged(true);
      setTimesheetPartData({
         ...timesheetPartData,
         qty: e.target.value,
      });
      }}/>
     </Box>
              <Box margin="dense" sx={{ mt: 1 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!timesheetPartData?.requiresReorder}
                      onChange={(e) => {
                        setTimesheetPartData({
                          ...timesheetPartData,
                          requiresReorder: e.target.checked,
                        });
                      }}
                      color="warning"
                    />
                  }
                  label="Requires reorder"
                />
                {timesheetPartData?.requiresReorder && (
                  <p style={{ margin: '2px 0 0 0', fontSize: 12, color: '#ed6c02' }}>
                    A reorder email will be sent automatically when this timesheet is marked as Complete.
                  </p>
                )}
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={handlePartDetail}>Cancel</Button>
              
              {timesheetPartData?.id === null ? (<Button onClick={createPart}>Add Part</Button>):(<Button onClick={updatePart}>Update Part</Button>)}
            </DialogActions>
          </Dialog>
        </React.Fragment>

      {/* Pinned header */}
      <Box sx={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 3, py: 1.5, borderBottom: '1px solid var(--border)', background: 'var(--surface)' }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>Timesheet Entry</Typography>
        {timesheetData?.id !== null && !isSynced ? (
          <Tooltip title="Delete timesheet">
            <IconButton aria-label="delete timesheet" onClick={deleteConfirmShow} sx={{ color: 'var(--fail)' }}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        ) : null}
      </Box>

      {/* Scrollable middle */}
      <Box sx={{ flex: 1, overflowY: 'auto', px: 3, py: 2 }}>

      {timesheetData?.omnixSyncStatus === 'SYNCED' && (
        <Box sx={{ mb: 1.5, p: 1.5, display: 'flex', alignItems: 'center', gap: 1.25, background: 'var(--pass-bg)', border: '1px solid var(--pass)', borderRadius: 'var(--r-sm)' }}>
          <Box component="span" sx={{ fontSize: 18, lineHeight: 1 }}>🔒</Box>
          <Box>
            <Typography variant="body2" sx={{ color: 'var(--pass)', fontWeight: 700 }}>SYNCED to Omnix — record locked</Typography>
            <Typography variant="caption" sx={{ color: 'var(--pass)' }}>
              Edits are locked to maintain accuracy with the linked job card.
            </Typography>
          </Box>
        </Box>
      )}
<Box 
          margin="dense">
         <TextField 
        fullWidth
          margin="dense"
          id="catNo" 
          label="Cat Number" 
          variant="outlined" 
          type="text" 
          InputProps={{
            readOnly: true,
          }}
          value={timesheetData?.catNo} 
        />
     </Box>
<Box 
          margin="dense">
         <TextField 
        fullWidth
          margin="dense"
          id="assetId" 
          label="Asset Number" 
          variant="outlined" 
          type="text" 
          InputProps={{
            readOnly: true,
          }}
          value={timesheetData?.assetId} 
        />
     </Box>
{/* <Box 
          margin="dense">
         <TextField 
        fullWidth
          margin="dense"
          id="catNo" 
          label="Job Number" 
          variant="outlined" 
          type="text"
          value={timesheetData?.jobNumber} 
    onChange={(e) => {
      setChanged(true);
      setTimesheetData({
         ...timesheetData,
         jobNumber: e.target.value,
      });
      }}/>
     </Box> */}
{/* Job Card — Omnix typeahead when linked, free-text fallback */}
{canUseOmnix && omnixLinkChecked && omnixLink && !omnixOffline && timesheetData?.omnixSyncStatus !== 'LEGACY' ? (
  <Box margin="dense" sx={{ mt: 1, mb: 1 }}>
    {timesheetData?.omnixJobCardId ? (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
        <Typography variant="caption" color="text.secondary">Job Card (Omnix)</Typography>
        <Chip size="small" label={timesheetData.jobCard} color="primary" />
        {!isSynced && (
          <Chip
            size="small"
            label="Change"
            variant="outlined"
            onClick={() => {
              setChanged(true);
              setTimesheetData({ ...timesheetData, jobCard: '-', jobNumber: '-', omnixJobCardId: null });
              setSelectedJobCard(null);
            }}
          />
        )}
      </Box>
    ) : (
      <Autocomplete
        options={jobCardOptions}
        getOptionLabel={(o) => `${o.jobCardNumber} — ${o.status}${o.customerPoNumber ? ` | ${o.customerPoNumber}` : ''}`}
        value={selectedJobCard}
        onChange={(_, val) => {
          setSelectedJobCard(val);
          setChanged(true);
          setTimesheetData({
            ...timesheetData,
            jobCard: val ? val.jobCardNumber : '-',
            jobNumber: val ? val.jobCardNumber : '-',
            omnixJobCardId: val ? val.id : null,
          });
        }}
        onInputChange={(_, v) => handleJobCardSearch(v)}
        onOpen={() => handleJobCardSearch('')}
        isOptionEqualToValue={(a, b) => a.id === b.id}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            margin="dense"
            label="Job Card (Omnix)"
            variant="outlined"
            placeholder="Search job cards…"
          />
        )}
        noOptionsText="No job cards found"
      />
    )}
  </Box>
) : (
  <Box margin="dense">
    {canUseOmnix && omnixOffline && (
      <Alert severity="warning" sx={{ mb: 1, py: 0 }}>Omnix offline — entering job card as free text</Alert>
    )}
    <TextField
      fullWidth
      margin="dense"
      id="jobCard"
      label="Job Card"
      variant="outlined"
      type="text"
      value={timesheetData?.jobCard}
      InputProps={{ readOnly: isSynced }}
      onChange={(e) => {
        setChanged(true);
        setTimesheetData({
          ...timesheetData,
          jobCard: e.target.value,
          // jobNumber is the legacy column jobCard replaced; parts reporting still reads it, so mirror every jobCard write.
          jobNumber: e.target.value,
        });
      }}
    />
  </Box>
)}
<Box 
          margin="dense">
         <TextField 
        fullWidth
          margin="dense"
          id="purchaseOrder"
          label="Purchase Order"
          variant="outlined"
          type="text"
          value={timesheetData?.purchaseOrder}
          InputProps={{ readOnly: isSynced }}
    onChange={(e) => {
      setChanged(true);
      setTimesheetData({
         ...timesheetData,
         purchaseOrder: e.target.value,
      });
      }}/>
     </Box>
<Box 
          margin="dense">
         <TextField 
        fullWidth
          margin="dense"
          id="lineItem"
          label="Line Item"
          variant="outlined"
          type="text"
          value={timesheetData?.lineItem}
          InputProps={{ readOnly: isSynced }}
    onChange={(e) => {
      setChanged(true);
      setTimesheetData({
         ...timesheetData,
         lineItem: e.target.value,
      });
      }}/>
     </Box>
<Box
          margin="dense">
       <FormControl fullWidth>
  <InputLabel>Job Status</InputLabel>
  <Select
    required
    label="Status"
    defaultValue={timesheetData?.status}
    disabled={isSynced}
    onChange={(e) => {
      setChanged(true);
      setTimesheetData({
         ...timesheetData,
         status: e.target.value,
      });
      }}>
    <MenuItem value="WIP">WIP</MenuItem>
    <MenuItem value="Complete">Complete</MenuItem>
  </Select>
</FormControl>
</Box>
     <LocalizationProvider dateAdapter={AdapterMoment}>
          <MobileDatePicker 
             slotProps={{ textField: { fullWidth: true } }}
             sx={{ mt: 1, mb: 1 }}
             margin="dense"
             id="workPerformedOn" 
             label="Work Performed On"
             variant="outlined" 
             format="DD-MM-YYYY"
             value={moment(timesheetData?.workPerformedOn)}
             maxDate={moment()}
             disabled={isSynced}
             onChange={(e) => {
               setChanged(true);
               setTimesheetData({
                  ...timesheetData,
                  workPerformedOn: (e === null ) ? '':moment(e._d).format('YYYY-MM-DD'),
               });
             }}
           />
      </LocalizationProvider>
<Box 
          margin="dense">
         <TextField 
        fullWidth
          margin="dense"
          id="timeSpent"
          label="Time Spent (Hours)"
          variant="outlined"
          type="number"
          value={timesheetData?.timeSpent}
          InputProps={{ readOnly: isSynced }}
          onChange={(e) => {
            setChanged(true);
            setTimesheetData({
               ...timesheetData,
            timeSpent: e.target.value,
            });
            }}
        />
     </Box>
<Box 
          margin="dense">
         <TextField 
        fullWidth
          margin="dense"
          id="notes"
          label="Notes"
          variant="outlined"
          multiline
          rows={6}
          type="text"
          value={timesheetData?.notes}
          InputProps={{ readOnly: isSynced }}
          onChange={(e) => {
            setChanged(true);
            setTimesheetData({
               ...timesheetData,
            notes: e.target.value,
            });
            }}
        />
     </Box>
      {timesheetData?.id !== null ? (
        <Paper variant="outlined" sx={{ width: '100%', mt: 2, overflow: 'hidden', borderColor: 'var(--border)' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.25, borderBottom: '1px solid var(--border)', background: 'var(--surface-2)' }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
              Parts Used{partsList && partsList.length ? ` (${partsList.length})` : ''}
            </Typography>
            {!isSynced ? (
              <Button size="small" variant="outlined"
                onClick={() => {
                  setTimesheetPartData(({
                    ...timesheetPartData,
                    id: null,
                    timesheetId: timesheetData.id,
                    partNo: null,
                    qty: null,
                    requiresReorder: false,
                  }),
                    handlePartDetail()
                  )
                }}
              >
                + Add Part
              </Button>
            ) : null}
          </Box>
          <TableContainer>
            <Table size="small" aria-label="parts used">
              <TableHead>
                <TableRow>
                  <TableCell align="left" sx={{ fontWeight: 600 }}>Part Number</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 600 }}>Qty</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 600 }}>Reorder</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(partsList && partsList.length > 0) ? partsList.map((part, partsIndex) => (
                  <TableRow key={partsIndex} hover onClick={() => { if (isSynced) return; setTimesheetPartData({ ...timesheetPartData, id: part.id, timesheetId: part.timesheetId, partNo: part.partNo, qty: part.qty, requiresReorder: !!part.requiresReorder, omnixItemId: part.omnixItemId || null }); handlePartDetail(); }} sx={{ cursor: isSynced ? 'default' : 'pointer', opacity: isSynced ? 0.6 : 1 }}>
                    <TableCell align="left" className="aims-mono">{part.partNo}</TableCell>
                    <TableCell align="center" className="aims-mono">{part.qty}</TableCell>
                    <TableCell align="center">
                      {part.requiresReorder ? <StatusChip domain="reorder" value="REORDER" label="Reorder" /> : null}
                    </TableCell>
                  </TableRow>
                )) : (
                  <TableRow>
                    <TableCell colSpan={3} align="center" sx={{ color: 'var(--muted)', py: 3 }}>
                      No parts added to this timesheet yet.{!isSynced ? ' Use “+ Add Part” to add one.' : ''}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      ):null}
     </Box>{/* end scrollable middle */}
     {/* Pinned footer */}
     <Box sx={{ flexShrink: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1.5, px: 3, py: 1.5, borderTop: '1px solid var(--border)', background: 'var(--surface)', flexWrap: 'wrap' }}>
       <Button variant="outlined" color="inherit"
          sx={{ color: 'var(--muted)', borderColor: 'var(--border-strong)' }}
          onClick={() => { if (onCancel) { onCancel(); } }}
       >
          {isSynced ? 'Close' : 'Cancel'}
       </Button>
       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
         {timesheetData.id === null ? (
         <Button variant="contained"
            disabled={!changed || timesheetData.notes === null || timesheetData.timeSpent === null || timesheetData.workPerformedOn === null || timesheetData.jobNumber === null || timesheetData.status === null }
            onClick={createTimesheet}
            >
            Create Timesheet and Add Parts
          </Button>
          ):null}
         {timesheetData.id !== null ? (
         <Button variant="contained"
            disabled={!changed || timesheetData?.omnixSyncStatus === 'SYNCED'}
            onClick={updateTimesheet}
            >
            Save Updates
          </Button>
          ):null}

         {/* Push to Omnix — only shown when timesheet is saved, has an Omnix job card, and status is Complete */}
         {timesheetData.id !== null && !changed && timesheetData.omnixJobCardId && timesheetData.status && timesheetData.status.toUpperCase() === 'COMPLETE' ? (
           <PushToOmnixButton timesheetData={timesheetData} setTimesheetData={setTimesheetData} baseUrl={baseUrl} />
         ) : null}
       </Box>
     </Box>
  </Box>
)};

function PushToOmnixButton({ timesheetData, setTimesheetData, baseUrl }) {
  const [pushing, setPushing] = useState(false);
  const [pushMsg, setPushMsg] = useState('');
  const syncStatus = timesheetData.omnixSyncStatus;

  if (syncStatus === 'SYNCED') {
    return <Box sx={{ mt: 1 }}><StatusChip domain="sync" value="SYNCED" label="Pushed to Omnix" dot size="md" /></Box>;
  }

  if (syncStatus === 'QUEUED' || syncStatus === 'SYNCING') {
    return <Box sx={{ mt: 1 }}><StatusChip domain="sync" value={syncStatus} label="Queued for Omnix…" dot size="md" /></Box>;
  }

  const handlePush = async () => {
    setPushing(true);
    setPushMsg('');
    try {
      const res = await fetch(baseUrl + 'omnix/push-timesheet', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          username: localStorage.getItem('username'),
          bToken: localStorage.getItem('bToken'),
        },
        body: JSON.stringify({ timesheetId: timesheetData.id }),
      });
      const data = await res.json();
      if (res.ok) {
        setTimesheetData(prev => ({ ...prev, omnixSyncStatus: 'QUEUED' }));
      } else {
        setPushMsg(data.message || 'Push failed.');
      }
    } catch (err) {
      setPushMsg('Network error.');
    } finally {
      setPushing(false);
    }
  };

  return (
    <Box sx={{ mt: 1 }}>
      {syncStatus === 'FAILED' && (
        <Alert severity="error" sx={{ mb: 1, py: 0 }}>Last push failed — you can retry.</Alert>
      )}
      {(syncStatus === 'NOT_SYNCED' || syncStatus === 'FAILED' || !syncStatus) ? (
        <Button variant="outlined" size="small" onClick={handlePush} disabled={pushing}>
          {pushing ? 'Pushing…' : 'Push to Omnix'}
        </Button>
      ) : null}
      {pushMsg ? <Typography variant="caption" sx={{ ml: 1 }}>{pushMsg}</Typography> : null}
    </Box>
  );
}

export default Timesheet
